const getDefaultState = () => {
  return {
    sincronizando: false,
  };
};

const syncStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setSincronizar(state, sync) {
      state.sincronizando = sync;
    },
  },
  actions: {},
  getters: {},
};

export default syncStore;
